export default "__VITE_ASSET__d1b3ce6b__"